import React, {Component} from 'react';
import {gpn} from "../GPN"
import Back from "../sections/Back";
import Req from "../req";
import jMoment from "jalali-moment";

class Logs extends Component {

    state = {
        logs: []
    };

    componentDidMount() {
        this.getClientLogs();
    }

    getClientLogs() {
        Req.get(`/logs/client`)
            .then(r => {
                let list = r ? r : [];
                list = list ? list : [];
                this.setState({logs: list});
            })
    }

    render() {
        let {logs = []} = this.state;

        return (
            <>
                <Back {...this.props}/>
                <br/>
                <div className="logs">
                    <h1>گزارشات کاربران</h1>
                    {
                        logs?.map((l, i) =>
                            <article key={"log" + i} className="ltr">
                                <div className="row ltr">
                                    <div className="col-auto">
                                        <span className="method">{l.method.toUpperCase()}</span>
                                    </div>
                                    <div className="col">
                                        <div className="url ltr tal">{l.url}</div>
                                        {
                                            ["POST", "PUT"].includes(l.method.toUpperCase()) ?
                                                <pre className="ltr tal">{JSON.stringify(l.body, null, 2)}</pre>
                                                : null
                                        }
                                    </div>
                                </div>
                                <div className="user-info">
                                    <div className="row justify-content-between">
                                        <div className="col-auto">
                                            <p className="full-name"><span>نام:</span><span>{l.fullName}</span></p>
                                        </div>
                                        <div className="col-auto">
                                            <p className="national-code">
                                                <span>کد ملی:</span><span>{l.nationalCode}</span></p>
                                        </div>
                                        <div className="col-auto">
                                            <p className="phone"><span>شماره:</span><span>{l.phone}</span></p>
                                        </div>
                                    </div>
                                    <div style={{textAlign: "center"}}>
                                        <a href={`/user/${l.user}`}
                                           style={{display: "inline-block"}}
                                           title="رفتن به صفحه کاربر">صفحه کاربر</a>
                                    </div>
                                    <p className="ip"><span>{l.ip}</span></p>
                                    <p className="created-at">
                                        <span>ثبت در:</span><span>{jMoment(l.createdAt).format("jYYYY/jMM/jDD HH:mm:ss")}</span>
                                    </p>
                                </div>
                            </article>
                        )
                    }
                </div>
            </>
        );
    }
}


export default gpn(Logs);